import PriorityCharityModal from './PriorityCharityModal';

export default PriorityCharityModal;
